import { Component, Input } from '@angular/core';

import { User } from '@core/objects/user';
import * as Models from '@app/models/ai.model';

@Component({
	selector: 'ai-question',
	templateUrl: './question.component.html',
	styleUrls: ['./question.component.scss'],
})
export class AIQuestionComponent {
	@Input() value: Models.AIQuestionModel;
	@Input() user: User;
}

